import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';
declare var $: any;
@Component({
    selector: 'app-entreprise-travaux',
    templateUrl: './entreprise-travaux.component.html',
    styleUrls: ['./entreprise-travaux.component.css'],
    standalone: false
})
export class EntrepriseTravauxComponent implements OnInit {
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Output() show = new EventEmitter<any>();


  listQualification= [];
  isEmpty: Boolean = true;
  classPresta: String = 'detailfact ';

  focusIndex = 0;
  tempClient: any = {};

  constructor(public common: CommonService) {
  }

  ngOnInit() {
    this.tempClient = Object.assign({}, this.detail);
    this.getListQual().then(data => {
      this.isEmpty = false;
      this.parseDate();
    });
  }

  parseDate() {
    this.listQualification.forEach(elt => {
      elt.dateAttribution = elt.dateAttribution ? moment(elt.dateAttribution, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY')
      : moment().format('DD/MM/YYYY');
      elt.dateEcheance = elt.dateEcheance ? moment(elt.dateEcheance, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY')
      : moment().format('DD/MM/YYYY');
    });
  }

  hideQual() {
    this.show.emit();
  }

  closeQual() {
    this.detail = this.tempClient;
    console.log(this.detail, this.tempClient);
    this.hideQual();
  }

  getListQual() {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBGestionQualificationAmiante',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      this.listQualification = datas.data || [];
      return datas.data;
    });
  }

  deleteLigne(row) {
    const temp = this.listQualification.filter(elt => elt !== row);
    this.listQualification = temp;
  }

  addLigne() {
    this.listQualification.push({
      index: this.listQualification.length, id: '1',
      dateAttribution: moment().format('DD/MM/YYYY'),
      dateEcheance: moment().format('DD/MM/YYYY')
    });
    this.listQualification = [...this.listQualification];
    const length = this.listQualification.length - 1;
    setTimeout(function () {
      $('.code' + (length)).focus();
    }, 600);
  }


  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  updateQual() {
    if (this.listQualification) {
      this.listQualification.forEach(elt => {
        elt.nomclass = 'QualificationAmiante';
        elt.client = {
          id: this.detail['id']
        };
      });
    }

    const param = {
      'servlet': 'DBGestionQualificationAmiante',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'LIST_QUALI': this.listQualification,
      }
    };
    console.log(this.detail, this.tempClient);
    this.hideQual();
    return this.common.post('', { param: param }).then(datas => {
    });
  }


}
